import { FC } from "react"
import { Link } from "react-router-dom"
import { CheckCircle } from "lucide-react"
import { Card, PrimaryBtn } from "../../../common/ui"

interface Props {
  orgId: string
  orgName: string
}

const SuccessMessage: FC<Props> = ({ orgId, orgName }) => (
  <Card className="max-w-lg mx-auto text-center">
    <div className="flex flex-col items-center py-8">
      <CheckCircle className="w-16 h-16 text-green-500 mb-4" />
      <h2 className="text-2xl font-semibold mb-2">Organization Created</h2>
      <p className="text-gray-600 mb-6">
        <strong>{orgName}</strong> has been successfully created.
      </p>
      <Link to={`/organizations/${orgId}`}>
        <PrimaryBtn>Manage Organization</PrimaryBtn>
      </Link>
    </div>
  </Card>
)

export default SuccessMessage
